import styled, { css } from "styled-components";
import { ReactComponent as Target } from "src/assets/icons/target.svg";

export const groupPresentationBox = 
    css`
        font-weight: bold;
        font-size: 0.85rem;
        color: var(--default-color-font);
        align-self: center;
        width:fit-content;
    `;

export const groupPresentationContainer = 
    css`
        border:1px solid var(--border-color);
        border-radius: 10px;
        background-color: var(--card-background);
        &.MuiGrid-root {
            margin:3px 0;
            padding:0.25rem 0.5rem;
        }
    `;

export const GroupPresentationTitle = styled.span`
    white-space:normal;
    display:-webkit-box;
    max-width:fit-content;
    -webkit-Line-clamp:3;
    -webkit-box-orient:vertical;
    overflow: hidden;
`;

export const StrategicIcon = styled(Target)`
    width: 16px; 
    height: 16px;
    fill: var(--input-font-color);
    g{
        fill: inherit;
        margin-right: "0.5rem";
    }
`;
